// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { SplitButton, MenuItem} from 'react-bootstrap';

// Modules
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';

const publicIcon = <i className="togo-icon togo-icon-1x togo-icon-globe"></i>;
const privateIcon = <i className="togo-icon togo-icon-1x togo-icon-lock-closed"></i>;

export class ChannelPrivacy extends React.Component {
    constructor(props) {
        super(props);
    }

    privacySelected(type) {
        if ((this.props.isContentDiscoverable && type === 'private') || (!this.props.isContentDiscoverable && type === 'public')) {
            const {t} = this.props;
            this.props.onPrivacyChange(type === 'public');
            const notificationText = type === 'public' ? t('notification.success.public') : t('notification.success.private');

            const mixpanelAttributes = {
                type,
                channelKey: window.location.pathname.split('/')[2]
            };
            mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.privacySelected}`, mixpanelAttributes);
            const successNotificationObject = {
                isActive: true,
                classes: 'success',
                type: 'success',
                iconType: 'check',
                text: notificationText
            };
            this.props.onNotificationChange(
                {
                    ...successNotificationObject,
                    animation: 'slideInDown'
                }
            );
            window.setTimeout(() => {
                this.props.onNotificationChange(
                    {
                        ...successNotificationObject,
                        animation: 'slideOutUp'
                    }
                );
            }, 6000);
        }
    }

    displayChannelPrivacySetting() {
        const {t} = this.props;
        const privacyIcon = this.props.isContentDiscoverable ? publicIcon : privateIcon;
        if (this.props.isChannelOwner) {
            return (
                <div className={"privacy-icon"}>
                    <SplitButton title={privacyIcon} id="dropdown-privacy" key={"1"}>
                        <MenuItem header>{t('privacy-setting.header')}</MenuItem>
                        <MenuItem key="public" id="public" eventKey="1" onClick={this.privacySelected.bind(this, 'public')}>
                            <div className="row">
                                <div className="col-md-2 col-xs-2 icon-adjust">
                                    {publicIcon}
                                </div>
                                <div className="col-md-10 col-xs-10">
                                    <div className="privacy-header">{t('privacy-setting.public.header')}</div>
                                    <span className="privacy-description">{t('privacy-setting.public.description')}</span>
                                </div>
                            </div>
                        </MenuItem>
                        <MenuItem key="private" eventKey="2" id="private" onClick={this.privacySelected.bind(this, 'private')}>
                            <div className="row">
                                <div className="col-md-2 col-xs-2 icon-adjust">
                                    {privateIcon}
                                </div>
                                <div className="col-md-10 col-xs-10">
                                    <div className="privacy-header">{t('privacy-setting.private.header')}</div>
                                    <span className="privacy-description">{t('privacy-setting.private.description')}</span>
                                </div>
                            </div>
                        </MenuItem>
                    </SplitButton>
                </div>
            );
        }
        return null;
    }

// ------------------------------------------- RENDER ------------------------------------------------
    render() {
        return (
            this.displayChannelPrivacySetting()
        );
    }
}

ChannelPrivacy.propTypes = {
    t: PropTypes.func,
    isChannelOwner: PropTypes.bool,
    description: PropTypes.string,
    onPrivacyChange: PropTypes.func,
    onNotificationChange: PropTypes.func,
    isContentDiscoverable: PropTypes.bool
};

export default translate(['translation'])(ChannelPrivacy);



// WEBPACK FOOTER //
// ./src/components/catalog/privacy-setting/channel-privacy.js